import { z } from "zod";
import { TFirebaseTimestamp, TFirebaseTimestampToISO } from "../deprecated";
import { TApiObjectBase } from "../base";
import { TDate } from "./date";

export const TCreatedBySource = z.enum([
  "user",
  "ai",
  "api",
  "email",
  "workflow",
]);

export type ICRUDByTDate = z.infer<typeof TCRUDByTDate>;
export const TCRUDByTDate = z.object({
  userID: z.optional(z.string()),
  date: TDate.optional(),
  apiClient: z
    .object({
      id: z.string(),
    })
    .optional(),
  workflow: z
    .object({
      id: z.string(),
    })
    .optional(),
  source: TCreatedBySource.optional(),
});

/**
 * @deprecated use ICRUDByTDate instead
 */
export type ICRUDBy = z.infer<typeof TCRUDBy>;
/**
 * @deprecated use TCRUDByTDate instead
 */
export const TCRUDBy = z.object({
  userID: z.optional(z.string()),
  date: TFirebaseTimestamp.optional(),
  apiClient: z
    .object({
      id: z.string(),
    })
    .optional(),
  workflow: z
    .object({
      id: z.string(),
    })
    .optional(),
  source: TCreatedBySource.optional(),
});

// API Base
/**
 * @deprecated use ICRUDBy instead
 */
export type IApiCRUDBy = z.infer<typeof TApiCRUDBy>;
/**
 * @deprecated use TCRUDBy instead
 */
export const TApiCRUDBy = z.object({
  userID: z.optional(z.string()),
  date: z.optional(z.string()),
  apiClient: z
    .object({
      id: z.string(),
    })
    .optional(),
  workflow: z
    .object({
      id: z.string(),
    })
    .optional(),
  source: TCreatedBySource.optional(),
});

/**
 * @deprecated use ICRUDBy instead
 */
export type IApiCrudByWithConverter = z.infer<typeof TApiObjectBase>;
/**
 * @deprecated use TCRUDBy instead
 */ export const TApiCrudByWithConverter = z.object({
  userID: z.optional(z.string()),
  date: z.optional(TFirebaseTimestampToISO),
  apiClient: z
    .object({
      id: z.string(),
    })
    .optional(),
  workflow: z
    .object({
      id: z.string(),
    })
    .optional(),
  source: TCreatedBySource.optional(),
});

/**
 * @deprecated use ICRUDBy instead
 */
export type ICreatedBy = z.infer<typeof TCRUDBy>;
